export default {
  methods: {
    /**
     * 格式化数字
     * @param {Number} number 要格式化的数字
     * @param {Number} length 保留小数点后位数
     */
    formatNumber(number, length) {
      if (!length) length = 2;
      return Number(Number(Number(number).toFixed(length)).toString());
    },
    /**
     * 四舍五入格式化数字
     * @param {Number} number 要格式化的数字
     * @param {Number} length 保留小数点后位数
     */
    roundNumber(number, length) {
      if (length === null) length = 2;
      let multiple = "1";
      for (var i = 0; i < length; i++) {
        multiple += "0";
      }
      let value = Math.round((number * Number(multiple)).toFixed(8)) / Number(multiple);
      return value;
    },

    /**
     * 限制只能输入正数
     * @param {*} val INPUT输入值
     * @param {*} obj 对象
     * @param {*} name 字段名称
     */
    limitPositiveNumber(val, obj, name) {
      let value = val.replace(/[^\d.]/g, "");
      this.$set(obj, name, value);
      this.$forceUpdate();
    },

    /**
     * 限制只能输入数值
     * @param {*} val INPUT输入值
     * @param {*} obj 对象
     * @param {*} name 字段名称
     */
    limitNumber(val, obj, name) {
      let value = val.replace(/[^-?\d.]/g, "");
      this.$set(obj, name, value);
      this.$forceUpdate();
    },

    /**
     * 限制只能输入正整数
     * @param {*} val INPUT输入值
     * @param {*} obj 对象
     * @param {*} name 字段名称
     */
    limitPositiveInteger(val, obj, name) {
      let value = val.replace(/[^\d]/g, "");
      this.$set(obj, name, value);
      this.$forceUpdate();
    },

    /**
     * 限制只能输入整数
     * @param {*} val
     * @param {*} obj
     * @param {*} name
     */
    limitInteger(val, obj, name) {
      let value = val.replace(/[^-?\d]/g, "");
      this.$set(obj, name, value);
      this.$forceUpdate();
    },

    /**
     * 验证输入的值是否大于最大限制
     * @param {*} val INPUT输入值
     * @param {*} obj 对象
     * @param {*} name 字段名称
     * @param {*} max 最大限值
     */
    validateMaxValue(val, obj, name, max) {
      if (Number(val) > Number(max)) {
        this.$set(obj, name, max);
        this.$message({
          message: this.$t("messageTip.numberMaxWarn") + ":" + max,
          type: "warning"
        });
      }
    },

    /**
     * INPUT失去焦点时 如果没有输入内容设置默认数值
     * @param {*} obj 对象
     * @param {*} name 字段名称
     */
    setNumberZero(obj, name) {
      if (!obj[name]) {
        this.$set(obj, name, 0);
      }
    },
    /**
     * INPUT失去焦点时验证数值是否是合法的值 并且根据要求保留相应的位数
     * @param {*} event 事件对象
     * @param {*} obj 对象
     * @param {*} name 字段名称
     * @param {*} size 小数点保留位数
     */
    setNumberValue(event, obj, name, size) {
      let value = String(event.target.value);
      let zeroIndex = value.indexOf("0");
      let decimalIndex = value.indexOf(".");
      if (zeroIndex === 0 && (decimalIndex !== 1 || decimalIndex < 0)) {
        value = String(Number(value));
      }
      let valueArray = value.split(".");
      if (valueArray.length === 1) {
        obj[name] = this.$set(obj, name, Number(value));
      } else if (valueArray.length === 2) {
        if (size) {
          obj[name] = parseFloat(Number(value).toFixed(size));
        } else {
          obj[name] = parseFloat(Number(value).toFixed(2));
        }
      } else {
        let tempValue = valueArray[0] + "." + valueArray[1];
        if (size) {
          obj[name] = parseFloat(Number(tempValue).toFixed(size));
        } else {
          obj[name] = parseFloat(Number(tempValue).toFixed(2));
        }
      }
    },
    /**
     * INPUT失去焦点时验证数值是否是合法的值 并且根据要求保留相应的位数 如果无输入内容设置为0
     * @param {*} event 事件对象
     * @param {*} obj 对象
     * @param {*} name 字段名称
     * @param {*} size 小数点保留位数
     */
    setNumberValueDefaultZero(event, obj, name, size) {
      this.setNumberZero(obj, name);
      this.setNumberValue(event, obj, name, size);
    },
    /**
     * INPUT失去焦点时验证数值是否是合法的值 并且根据要求保留相应的位数 如果无输入内容设置为0
     * @param {*} event 事件对象
     * @param {*} obj 对象
     * @param {*} name 字段名称
     * @param {*} defaultVal 默认数值
     * @param {*} size 小数点保留位数
     */
    setNumberDefaultValue(event, obj, name, defaultVal, size) {
      if (!obj[name]) {
        this.$set(obj, name, defaultVal);
      }
      this.setNumberValue(event, obj, name, size);
    },
    /**
     * INPUT失去焦点时验证万元金额是否是合法的值 并且根据要求保留相应的位数
     * @param {*} event 事件对象
     * @param {*} obj 对象
     * @param {*} name 字段名称
     */
    setTenThousandNumberValue(event, obj, name) {
      this.setNumberValue(event, obj, name, 6);
    },
    /**
     * INPUT失去焦点时验证万元金额是否是合法的值 并且根据要求保留相应的位数 如果无输入内容设置为0
     * @param {*} event 事件对象
     * @param {*} obj 对象
     * @param {*} name 字段名称
     */
    setTenThousandNumberValueDefaultZero(event, obj, name) {
      this.setNumberZero(obj, name);
      this.setTenThousandNumberValue(event, obj, name, 6);
    },
    /**
     * INPUT失去焦点时验证万元金额是否是合法的值 并且根据要求保留相应的位数 如果无输入内容设置为0 验证是否超过最大限制数量
     * @param {*} event 事件对象
     * @param {*} obj 对象
     * @param {*} name 字段名称
     * @param {*} max 最大数值限制
     */
    setTenThousandNumberValueDefaultZeroAndMax(event, obj, name, max) {
      this.setNumberZero(obj, name);
      this.setTenThousandNumberValue(event, obj, name, 6);
      this.validateMaxValue(Number(event.target.value), obj, name, max);
    },
    /**
     * 格式化金额数字千位分割符
     * @param {*} val 金额数字
     */
    formatNumberThousandSeparator(val) {
      let value = (+val || 0)
        .toString()
        .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
      return value;
    }
  }
};
